export const LoyaltyAuthenticatedComponent = {
    bindings: {
        appliedRedemptionAmount: '<',
        availableRedemptionAmount: '<',
        isRedeemLoading: '<',
        isRedemptionApplied: '<',
        isRedeemUndoLoading: '<',
        onRedeem: '<',
        onRedeemUndo: '<',
        remainingRedemptionAmount: '<'
    },
    template: `
        <oo-card>
            <oo-card-header>
                <p>Rewards</p>
            </oo-card-header>

            <oo-card-body>
                <div class="column expand column-md-6 column-sm-12">
                    <div class="flex-row centered-row-md" c-type="title-md-primary">
                        <span ng-if="!$ctrl.isRedemptionApplied">
                            You have {{$ctrl.availableRedemptionAmount | currency}} in available rewards.
                        </span>
                        <span ng-if="$ctrl.isRedemptionApplied">
                            You have redeemed {{$ctrl.appliedRedemptionAmount | currency}} of your rewards.
                            <br>
                            New balance is {{$ctrl.remainingRedemptionAmount | currency}}
                        </span>
                    </div>
                </div>

                <div class="column column-sm-12 column-md-6 column-lg-4">
                    <oo-button
                        is-loading="$ctrl.isRedeemLoading"
                        id="button-redeem-loyalty"
                        types="button button-secondary"
                        button-type="button"
                        button-click="$ctrl.onRedeem()"
                        ng-if="!$ctrl.isRedemptionApplied"
                    >Redeem Now!</oo-button>

                    <oo-button
                        is-loading="$ctrl.isRedeemUndoLoading"
                        id="button-redeem-loyalty-undo"
                        types="button button-secondary"
                        button-type="button"
                        button-click="$ctrl.onRedeemUndo()"
                        ng-if="$ctrl.isRedemptionApplied"
                    >Undo</oo-button>
                </div>
            </oo-card-body>
        </oo-card>
    `
};
